import React, { useEffect } from 'react';
import * as requests from 'store/actions/requests.js';
import { useHistory } from 'react-router-dom';
import { Trans } from "@lingui/react/macro";
import { getDomainSubdomain } from 'utils/helpers';

const LandingDemo = () => {
  const history = useHistory();
  const { domain, subDomain } = getDomainSubdomain(window.location.hostname);
  const isFastHtmlPage = domain === 'localhost' || domain === 'tryfasthtml.com';
  const isProd = !domain.includes('localhost');
  const exerciceIdFastHtmlProd = 1396;
  const exerciceIdFastHtmlLocal = 86;
  const fastHtmlUniversIdentifier = 'fasthtml';

  useEffect(() => {
    requests.createUserDemo(domain, subDomain).then((res) => {
      //   TODO update the context directly
      if (isFastHtmlPage) {
        const exerciceId = isProd ? exerciceIdFastHtmlProd : exerciceIdFastHtmlLocal;
          window.location.href = `/${fastHtmlUniversIdentifier}/exercice/${exerciceId}`;

      } else {
        window.location.href = '/dashboard';
      }
    });
  }, [subDomain, history, domain, isFastHtmlPage, isProd]);

  return (
    <div className="fixed inset-0 bg-black/50 flex flex-col items-center justify-center gap-4">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-white border-t-transparent" />
      <p className="text-white text-lg">
        <Trans>Création de votre compte démo...</Trans>
      </p>
    </div>
  );
};

export default LandingDemo;
